var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.761 3.545a5.595 5.595 0 0 1 5.214 1.523l1.595 1.5H12.65a.973.973 0 0 0 0 1.945h4.36A.97.97 0 0 0 18 7.54V3.162a.973.973 0 1 0-1.946 0V5.29L14.318 3.66a7.54 7.54 0 0 0-12.43 2.826.973.973 0 1 0 1.834.65 5.595 5.595 0 0 1 4.04-3.591ZM0 10.459c0-.537.436-.973.973-.973h4.378a.973.973 0 1 1 0 1.946H3.43l1.596 1.5a5.595 5.595 0 0 0 9.253-2.067.973.973 0 1 1 1.835.649A7.54 7.54 0 0 1 3.682 14.34l-1.736-1.631v2.128a.973.973 0 1 1-1.946 0V10.46Z",
    clipRule: "evenodd"
  })));
};
export default SvgRefresh;